import VueCookie from "@/plugins/myCookie"

function readUserInfo(state) {
    let saved = VueCookie.get('user_info');
    if (saved) {
        let payload = "";
        try {
            payload = JSON.parse(saved);
            if (payload) {
                state.name = payload.name;
                state.token = payload.token;
                state.email = payload.email;
                state.role_level = payload.role_level;
                state.user_id = payload.user_id;
                state.department = payload.department;
                state.mobile = payload.mobile;
                state.time = payload.time;
                state.disabled = parseInt(payload.disabled);
                state.ulogo = payload.ulogo;
                state.logo = payload.logo;
                state.allow_room_group = payload.allow_room_group;
                state.medal = payload.medal;
                state.tencent_user_ready = payload.tencent_user_ready;
            }
        } catch (e) {
            console.log(payload)
            console.error(e);
        }
    }
}

export default {
    namespaced: true,
    state: {
        name: '',
        token: '',
        email: '',
        role_level: 0,
        user_id: '',
        mobile: '',
        time: 0,
        disabled: 0,
        logo: null,
        ulogo: null,
        allow_room_group: null,
        medal: null,
    },
    mutations: {
        setUserInfo(state, payload) {
            state.name = payload.name;
            if (payload.token) state.token = payload.token;
            state.email = payload.email;
            state.role_level = payload.role_level;
            state.user_id = payload.user_id;
            state.department = payload.department;
            state.mobile = payload.mobile;
            state.disabled = parseInt(payload.disabled);
            state.ulogo = payload.ulogo;
            state.logo = payload.logo;
            state.allow_room_group = payload.allow_room_group;
            state.medal = payload.medal;
            state.tencent_user_ready = payload.tencent_user_ready;
            payload.token = state.token;
            payload.time = new Date().getTime();
            VueCookie.set('user_info', JSON.stringify(payload), {expires: false});
        },

        setUserTime(state) {
            state.time = new Date().getTime();
            VueCookie.set('user_info', JSON.stringify(state), {expires: false});
        },

        readUserInfo(state) {
            readUserInfo(state);
        },
        clear(state) {
            state.name = '';
            state.id = '';
            state.token = '';
            state.email = '';
            state.role_level = 0;
            state.user_id = '';
            state.department = '';
            state.mobile = '';
            state.time = 0;
            state.disabled = 0;
            state.ulogo = null;
            state.logo = null;
            state.allow_room_group = null;
            state.medal = null;
            state.tencent_user_ready = false;

            VueCookie.delete('user_info');
        },
    },
    actions: {},
    getters: {
        user(state) {
            if (!(state.token && state.name && state.id)) {
                readUserInfo(state);
            }
            return state;
        }
    }
}
